module.exports = __webpack_public_path__ + "img/mapipay1.fff3d20a.png";